import React, { useState } from 'react';
import { startCheckout } from '../lib/shopify';
interface BuyButtonProps {
  label: string;
  className?: string;
  loadingLabel?: string;
}
export function BuyButton({
  label,
  className = '',
  loadingLabel = 'Loading…'
}: BuyButtonProps) {
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    await startCheckout();
  };
  return <button onClick={handleClick} disabled={loading} className={`${className} disabled:opacity-70 disabled:cursor-wait`} data-id="element-121">
      {loading ? loadingLabel : label}
    </button>;
}